export const environment = {
  production: true,
  viewerBaseUrl: '/app/',
  providers: [],
};
